<template>
  <div>
    <CRow>
      <CCol sm="12">
        <CButton @click="print()" color="info" style="width: 9rem" class="float-right">
          <CIcon name="cil-print" />ພິມລາຍງານ
        </CButton>
      </CCol>
      <CCol sm="12">
        <hr />
      </CCol>
      <CCol sm="12">
        <div id="print-contract-view">
          <CRow>
            <CCol sm="8"></CCol>
            <CCol sm="3">
              <CImg src="images/3c_link_logo.png" width="100%" />
            </CCol>
            <CCol sm="1"></CCol>
            <CCol sm="12">
              <br />
            </CCol>
            <CCol sm="8"></CCol>
            <CCol sm="4">
              <strong>ເລກທີສັນຍາ : {{reportCont.cont_no}}</strong>
            </CCol>
            <CCol sm="8"></CCol>
            <CCol sm="4">
              <strong>ວັນທີ : {{reportCont.cont_date}}</strong>
            </CCol>
            <CCol sm="12">
              <br />
            </CCol>
            <CCol sm="12" class="text-center">
              <h5>
                <u>
                  <b>ອິນເຕີເນັດບ້ານ ແລະ ຫ້ອງການ ຄວາມໄວສູງ</b>
                </u>
              </h5>
            </CCol>
            <CCol sm="12">
              <br />
            </CCol>
            <CCol sm="12">
              <CRow>
                <CCol sm="1"></CCol>
                <CCol>
                  <CRow>
                    <CCol sm="12">
                      <h5>1. ຂໍ້ມູນລຸກຄ້າ</h5>
                    </CCol>
                    <CCol sm="12">
                      <strong>ລະຫັດລູກຄ້າ : {{reportCont.cus_id}}</strong>
                    </CCol>
                    <CCol sm="6">
                      <strong>ຊື່ ແລະ ນາມສະກູນ : {{reportCont.cus_full_name}}</strong>
                    </CCol>
                    <CCol sm="6">
                      <strong>ປະເພດລູກຄ້າ : {{reportCont.cus_group}}</strong>
                    </CCol>
                    <CCol sm="6">
                      <strong>ເບີໂທລະສັບ : {{reportCont.cus_tel}}</strong>
                    </CCol>
                    <CCol sm="6">
                      <strong>Email : {{reportCont.cus_email}}</strong>
                    </CCol>
                    <CCol sm="12">
                      <strong>ທີ່ຢູ່ : {{reportCont.cus_address}}</strong>
                    </CCol>
                    <CCol sm="12">
                      <br />
                    </CCol>
                    <CCol sm="12">
                      <h5>2. ຂໍ້ມູນເລືອກເພັກເກັດ ແລະ ວິທີການຊຳລະເງິນ</h5>
                    </CCol>
                    <CCol sm="7">
                      <strong>ເລືອກໃຊ້ເພັກເກັດ : {{reportCont.service_name}}</strong>
                    </CCol>
                    <CCol sm="5">
                      <strong>ລາຄາບໍລິການ : {{reportCont.service_price | numFormat }} / {{reportCont.service_unit}}</strong>
                    </CCol>
                    <CCol sm="12">
                      <strong>ລາຍລະອຽດເພີ່ມເຕີມ : {{reportCont.con_sv_remark}}</strong>
                    </CCol>
                    <CCol sm="12">
                      <br />
                    </CCol>
                    <CCol sm="12">
                      <h5>3. ຂໍ້ມູນອຸປະກອນການຕິດຕັ້ງ</h5>
                    </CCol>
                    <CCol sm="12" class="position-relative table-responsive">
                      <table class="table table-bordered">
                        <thead>
                          <tr>
                            <th class="text-center">
                              <strong>ລດ</strong>
                            </th>
                            <th class="text-center">
                              <strong>Serial</strong>
                            </th>
                            <th class="text-center">
                              <strong>Max Address</strong>
                            </th>
                            <th class="text-center">
                              <strong>ຊື່ອຸປະກອນ</strong>
                            </th>
                            <th class="text-center">
                              <strong>ຈໍານວນ</strong>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="row in reportApplList" :key="row.index">
                            <td class="text-center">{{row.index}}</td>
                            <td>{{row.appl_serial}}</td>
                            <td>{{row.appl_max_add}}</td>
                            <td>
                              {{row.appl_name}}
                              <br />
                              ( {{row.appl_remark}} )
                            </td>
                            <td class="text-center">{{row.appl_amount}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </CCol>
                    <CCol sm="12">
                      <br />
                    </CCol>
                    <CCol sm="12">
                      <h5>4. ຂໍ້ມູນການຊໍາລະເງິນ</h5>
                    </CCol>
                    <CCol sm="12" class="position-relative table-responsive">
                      <table class="table table-bordered">
                        <thead>
                          <tr>
                            <th class="text-center w-50">
                              <strong>ວັນທິຈ່າຍ</strong>
                            </th>
                            <th class="text-center w-50">
                              <strong>ເລກທີບິນຮັບເງິນ</strong>
                            </th>
                            <th class="text-center">
                              <strong>ຈໍານວນເງິນລວມ</strong>
                            </th>
                            <th class="text-center">
                              <strong>ສະກຸນເງິນ</strong>
                            </th>
                            <th class="text-center">
                              <strong>ຜູ້ອອກບິນ</strong>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="row in reportInvList" :key="row.inv_date">
                            <td class="text-center">{{row.inv_date}}</td>
                            <td>{{row.inv_no}}</td>
                            <td class="text-right">{{row.inv_price_total | numFormat(',000.00')}}</td>
                            <td class="text-center">{{row.inv_curency}}</td>
                            <td>{{row.inv_by}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </CCol>
                    <CCol sm="12">
                      <br />
                    </CCol>
                    <CCol sm="12">
                      <h5>5. ພັນທະ ແລະ ເງືອນໄຂຊໍາລະເງິນ</h5>
                    </CCol>
                    <CCol sm="12">
                      <strong> ສັນຍາສະບັບນີ້ແມ່ນກຳນົດເວລາ ແລະ ລູກຄ້າບໍ່ສາມາດຍົກເລີກສັນຍາກ່ອນ ( {{reportCont.cont_end_date}} ) ໄດ້ຖ້າຫາກວ່າລູກຄ້າມີຈຸດປະສົງທີ່ຈະຍົກເລີກສັນຍາ: ແມ່ນລູກຄ້າຈະບໍ່ໄດ້ຮັບເງິນທີ່ຈ່າຍໃຫ້ແກ່ 3ຊີລິ້ງ (ໃນກໍລະນີທີ່ລູກຄ້າຈ່າຍໄວ້ລ່ວງໜ້າ) ການໂອນທີ່ຢູ່ແມ່ນບໍ່ສາມາດເຮັດໄດ້, ເຊິ່ງລູກຄ້າສາມາດເຮັດໄດ້ກໍຕໍ່ເມື່ອພາຍຫຼັງທີ່ໄດ້ຮັບໃຊ້ບໍລິການຄົບ. ບໍ່ດັ່ງນັ້ນລູກຄ້າຈະຕ້ອງໄດ້ຈ່າຍເງິນ 400.000ກີບ ເປັນຄ່າຍົກຍ້ານອຸປະກອນ (ສະເພາະສະຖານທີ່ 3ຊີລິ້ງສາມາດຕິດຕັ້ງໄດ້) ການຊຳລະເງິນຄ່າຕິດຕັ້ງ ແລະ ຄ່າອຸປະກອນແມ່ນຈະຕ້ອງຈ່າຍກ່ອນລ່ວງໜ້າການຕິດຕັ້ງໃບຮຽກເກັບເງິນໃນເດືອນທຳອິດແມ່ນຈະຖືກເກັບພ້ອມໃນຄ່າຕິດຕັ້ງ ແລະ ຄ່າອຸປະກອນ(ຖ້າມີ) ຈາກນັ້ນ ກໍ່ແມ່ນຮຽກເກັບເປັນລາຍເດືອນ ທຸກໆເດືອນ 3ຊີລິ້ງຈະສົ່ງໃບເກັບເງີນສ່ວນຫຼາຍຈະຜ່ານທາງອີແມວ ເຖິງລູກຄ້າໃນລະຫວ່າງ ວັນທີ 20-30 ການຊຳລະເງິນແມ່ນຈຳເປັນຕ້ອງຈ່າຍກ່ອນວັນທີ 1-5 ຂອງແຕ່ລະເດືອນ ຖ້າບໍ່ສາມາດປະຕິບັດໄດ້, ການເຊື່ອຕໍ່ຂອງສັນຍານອິນເຕີເນັດແມ່ນຈະຖືກລະງັບຊົ່ວຄາວຈາກລະບົບຈົນກວ່າຈະມີການຊຳລະເງິນລູກຄ້າ ສຳລັບລູກຄ້າທີ່ຈ່າຍລ່ວງໜ້າ ຕາມໂປໂມຊັ່ນ ແມ່ນ ຈະຕ້ອງຈ່າຍ ຕາມມື້ທີ່ຕິດຕັ້ງ ແລະ ຕ້ອງແຈ້ງໃຫ້ແກ່ບໍລິສັດຮັບຊາບກ່ອນຈະໝົດສັນຍາ 15 ວັນ ຖ້າບໍ່ດັ່ງນັ້ນ, ສັນຍາຈະຖືຕໍ່ໂດຍອັດຕະໂນມັດ. ລູກຄ້າສາມາດເພີ່ມຄວາມໄວ ແລະ ລົດຄວາມໄວອິນເຕີເນັດໄດ້ໜຶ່ງເທື່ອຕໍ່ເດືອນ ຍອດຄ້າງຈ່າຍຈະຖືກໂອນໄປໃສ່ໃນບິນຂອງເດືອນຕໍ່ໄປ. ໃນກໍລະນີທີ່ມີການລະເມີດຕໍ່ພັນທະ ແລະ ເງື່ອນໄຂສັນຍາຂອງບໍລິສັດ 3ຊີລິ້ງ ສາມາດຍົກເລີກສັນຍາສະບັບນີ້ໄດ້. ຂ້າພະເຈົ້າໄດ້ອ່ານບັນດາພັນທະ ແລະ ເງື່ອນໄຂຂອງສັນຍາສະບັບນີ້ແລ້ວ, ກໍເຫັນດີ ແລະ ປະຕິບັດຕາມ</strong>
                    </CCol>
                    <CCol sm="12">
                      <br /><br />
                    </CCol>
                    <CCol sm="6" class="text-center" >
                      <strong><b> ລາຍເຊັນລູກຄ້າ </b></strong>
                    </CCol>
                    <CCol sm="6" class="text-center" >
                     <strong><b> ລາຍເຊັນພະນັກງານ 3C-LINK </b></strong>
                    </CCol>
                  </CRow>
                </CCol>
                <CCol sm="1"></CCol>
              </CRow>
            </CCol>
          </CRow>
        </div>
      </CCol>
    </CRow>
  </div>
</template>
<script>
export default {
  name: "InvoiceView",
  props: {
    reportCont: {
      type: Object,
      required: true,
    },
    reportInvList: {
      type: Array,
      required: true,
    },
    reportApplList: {
      type: Array,
      required: true,
    },
  },
  methods: {
    print() {
      this.$htmlToPaper("print-contract-view");
    },
  },
};
</script>